import { ListingType, SortingOption } from '@/types';

/**
 * Validates and sanitizes a sortBy query parameter value
 * @param value - The value to validate
 * @returns A valid SortingOption or the default value
 */
export function sanitizeSortByParam(value: unknown): SortingOption {
  // If the value is not a string, return the default
  if (typeof value !== 'string') {
    return SortingOption.DEFAULT;
  }

  // Check if the value is one of the valid enum values
  const validValues = Object.values(SortingOption);
  return validValues.includes(value as SortingOption)
    ? (value as SortingOption)
    : SortingOption.DEFAULT;
}

/**
 * Validates and sanitizes a listingType query parameter value
 * @param value - The value to validate
 * @returns A valid ListingType or the default value
 */
export function sanitizeListingTypeParam(value: unknown): ListingType {
  // If the value is not a string, return the default
  if (typeof value !== 'string') {
    return ListingType.ANY;
  }

  // Check if the value is one of the valid enum values
  const validValues = Object.values(ListingType);
  return validValues.includes(value as ListingType) ? (value as ListingType) : ListingType.ANY;
}
